import React, { useState } from 'react';
import { useMutation, gql } from '@apollo/client';
import HistorialAcusadoModal from './HistorialAcusadoModal';
import { formatDate } from '../utils/formatDate';

const ESTADOS = [
  { value: 'en_investigacion', label: 'En investigación' },
  { value: 'en_juicio', label: 'En juicio' },
  { value: 'sentenciado', label: 'Sentenciado' },
  { value: 'absuelto', label: 'Absuelto' },
];

const UPDATE_ESTADO = gql`
  mutation UpdateEstado($id: uuid!, $estado: estado_procesal_enum!) {
    update_acusados_by_pk(pk_columns: { id: $id }, _set: { estado_actual: $estado }) {
      id
      estado_actual
      updated_at
    }
  }
`;

const INSERT_TESTIMONIO = gql`
  mutation InsertTestimonio($object: testimonios_insert_input!) {
    insert_testimonios_one(object: $object) {
      id
    }
  }
`;

const INSERT_AUDIO = gql`
  mutation InsertAudio($object: audios_insert_input!) {
    insert_audios_one(object: $object) {
      id
    }
  }
`;

const INSERT_DOCUMENTO = gql`
  mutation InsertDocumento($object: documentos_insert_input!) {
    insert_documentos_one(object: $object) {
      id
    }
  }
`;

export default function DetalleAcusadoModal({ acusado, onClose, onEstadoActualizado }) {
  const [estado, setEstado] = useState(acusado.estado_procesal);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [verHistorial, setVerHistorial] = useState(false);
  const [tTestigo, setTTestigo] = useState('');
  const [tTexto, setTTexto] = useState('');
  const [aNombre, setANombre] = useState('');
  const [aTranscripcion, setATranscripcion] = useState('');
  const [dNombre, setDNombre] = useState('Contrato Defensa');
  const [dContenido, setDContenido] = useState('Yo, {{abogado}}, represento a {{acusado}} en el expediente {{expediente}}.');
  const [info, setInfo] = useState('');
  const [updateEstado] = useMutation(UPDATE_ESTADO);
  const [insertTestimonio] = useMutation(INSERT_TESTIMONIO);
  const [insertAudio] = useMutation(INSERT_AUDIO);
  const [insertDocumento] = useMutation(INSERT_DOCUMENTO);

  const handleGuardar = async () => {
    setGuardando(true);
    try {
      const res = await updateEstado({ variables: { id: acusado.acusado_id, estado } });
      if (res.data?.update_acusados_by_pk) {
        onEstadoActualizado({
          ...acusado,
          estado_procesal: res.data.update_acusados_by_pk.estado_actual,
          fecha_actualizacion: res.data.update_acusados_by_pk.updated_at
            ? formatDate(res.data.update_acusados_by_pk.updated_at)
            : acusado.fecha_actualizacion,
        });
      }
      setError('');
      onClose();
    } catch (err) {
      setError('No se pudo actualizar el estado');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.3)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Detalle del Acusado</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div><b>Nombre:</b> {acusado.nombre}</div>
            <div><b>Cédula:</b> {acusado.cedula}</div>
            <div><b>Grado:</b> {acusado.grado}</div>
            <div><b>Unidad:</b> {acusado.unidad}</div>
            <div><b>Dirección:</b> {acusado.direccion}</div>
            <div><b>Estado civil:</b> {acusado.estado_civil}</div>
            <div><b>Edad:</b> {acusado.edad}</div>
            <div><b>Fecha de nacimiento:</b> {formatDate(acusado.fecha_nacimiento)}</div>
            {acusado.foto && (
              <div className="my-2"><img src={acusado.foto} alt="Foto acusado" style={{ maxWidth: 120, borderRadius: 8 }} /></div>
            )}
            <div><b>Estado procesal:</b></div>
            <select className="form-select mt-1 mb-2" value={estado} onChange={e => setEstado(e.target.value)}>
              {ESTADOS.map(eo => <option key={eo.value} value={eo.value}>{eo.label}</option>)}
            </select>
            <div className="d-flex justify-content-between align-items-center">
              <div><b>Fecha actualización:</b> {formatDate(acusado.fecha_actualizacion)}</div>
              <button className="btn btn-outline-secondary btn-sm" onClick={() => setVerHistorial(true)}>Ver historial</button>
            </div>
            {error && <div className="alert alert-danger py-1 mt-2">{error}</div>}
            {info && <div className="alert alert-success py-1 mt-2">{info}</div>}

            <hr />
            <h6>Agregar testimonio</h6>
            <div className="row g-2 mb-2">
              <div className="col-4"><input className="form-control" placeholder="Testigo" value={tTestigo} onChange={e => setTTestigo(e.target.value)} /></div>
              <div className="col-8"><input className="form-control" placeholder="Testimonio" value={tTexto} onChange={e => setTTexto(e.target.value)} /></div>
            </div>
            <button className="btn btn-outline-primary btn-sm mb-3" onClick={async () => {
              if (!tTestigo || !tTexto) return setError('Completa testigo y testimonio');
              setError('');
              await insertTestimonio({
                variables: { object: { acusado_id: acusado.acusado_id, testigo: tTestigo, texto: tTexto } },
              });
              setTTestigo(''); setTTexto(''); setInfo('Testimonio agregado'); setTimeout(() => setInfo(''), 1500);
            }}>Guardar testimonio</button>

            <h6>Subir audio + transcripción</h6>
            <div className="row g-2 mb-2">
              <div className="col-4"><input className="form-control" placeholder="Nombre de archivo" value={aNombre} onChange={e => setANombre(e.target.value)} /></div>
              <div className="col-8"><input className="form-control" placeholder="Transcripción" value={aTranscripcion} onChange={e => setATranscripcion(e.target.value)} /></div>
            </div>
            <button className="btn btn-outline-primary btn-sm mb-3" onClick={async () => {
              if (!aNombre) return setError('Indica un nombre de archivo');
              setError('');
              await insertAudio({
                variables: { object: { acusado_id: acusado.acusado_id, nombre: aNombre, transcripcion: aTranscripcion || '(pendiente de transcripción)' } },
              });
              setANombre(''); setATranscripcion(''); setInfo('Audio registrado'); setTimeout(() => setInfo(''), 1500);
            }}>Guardar audio</button>

            <h6>Generar documento</h6>
            <div className="row g-2 mb-2">
              <div className="col-4"><input className="form-control" placeholder="Nombre" value={dNombre} onChange={e => setDNombre(e.target.value)} /></div>
              <div className="col-8"><input className="form-control" placeholder="Plantilla" value={dContenido} onChange={e => setDContenido(e.target.value)} /></div>
            </div>
            <button className="btn btn-outline-primary btn-sm" onClick={async () => {
              const contenido = dContenido
                .replace('{{abogado}}', 'Dr. Legal')
                .replace('{{acusado}}', acusado.nombre)
                .replace('{{expediente}}', 'EXP-1234');
              await insertDocumento({
                variables: { object: { acusado_id: acusado.acusado_id, nombre: dNombre, contenido } },
              });
              setInfo('Documento generado'); setTimeout(() => setInfo(''), 1500);
            }}>Generar</button>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose} disabled={guardando}>Cerrar</button>
            <button className="btn btn-primary" onClick={handleGuardar} disabled={guardando}>Guardar cambios</button>
          </div>
        </div>
      </div>
      {verHistorial && <HistorialAcusadoModal acusado={acusado} onClose={() => setVerHistorial(false)} />}
    </div>
  );
}
